import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { useAdsCabinetsStore } from "@/store/dictionaries/ads_cabinets";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";
import JsonWithTooltip from "@/shared/table/JsonWithTooltip.vue";

import { convertDateFromUTC } from "@/services/utils/DateParser";
import { getUserFullName } from "@/services/utils/Names";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdsCabinetsTable',
  props: {
    adsCabinets: {},
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;
const router = useRouter();
const store = useAdsCabinetsStore();
const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

let modifiedId = ref(0);
const confirmVisible = ref({
  history: false,
  delete: false,
});
const blockedButtonDelete = ref(false);
const menu = ref();
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    archive: "no_archive",
    command: () => {
      router.push({ name: "adsCabinet", params: { id: modifiedId.value } });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    archive: "both",
    command: () => {
      confirmVisible.value.delete = true;
    },
  },
]);

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const toggle = (elemId: number, event: any) => {
  modifiedId.value = elemId;
  menu.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

const deleteAdsCabinet = () => {
  blockedButtonDelete.value = true;
  store
    .deleteAdsCabinet(modifiedId.value)
    .finally(() => {
      emits("updateTable");
      blockedButtonDelete.value = false;
      confirmVisible.value.delete = false;
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.adsCabinets,
      class: _normalizeClass([[
      _ctx.adsCabinets && _ctx.adsCabinets.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
      stripedRows: "",
      onSort: sortTable,
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      dataKey: "id",
      columnResizeMode: "expand"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"min-width":"44px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "name",
          header: "Название кабинета",
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_RouterLink, {
              to: { name: 'adsCabinet', params: { id: slotProps.data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "source",
          header: "Площадка"
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.source.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "login",
          header: "Логин",
          sortable: ""
        }),
        _createVNode(_unref(Column), {
          field: "external_id",
          header: "Внешний id",
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.external_id || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "cuser",
          header: "Автор",
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(getUserFullName)(slotProps.data.cuser)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "is_stat",
          header: "Сбор статистики в SSP"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.is_statistics_required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Да"))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "Нет"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "is_stat",
          header: "Проверка имени в SSP"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.is_naming_checked)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Да"))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "Нет"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "use_in_ui",
          header: "Использовать в UI"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.use_in_ui)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Да"))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Нет"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "settings",
          header: "Settings",
          style: {"max-width":"200px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(JsonWithTooltip, {
              value: slotProps.data.settings,
              "max-length": 50
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "ctime",
          header: "Дата создания",
          sortable: "",
          style: {"min-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "mtime",
          header: "Дата обновления",
          sortable: "",
          style: {"min-width":"173px","max-width":"173px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.mtime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data.id, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_9, 8, _hoisted_7)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "class", "loading"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(DeleteConfirmDialog, {
      "deleted-name": "рекламный кабинет",
      visible: confirmVisible.value.delete,
      blocked: blockedButtonDelete.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (confirmVisible.value.delete = false)),
      onDelete: deleteAdsCabinet
    }, null, 8, ["visible", "blocked"]),
    _createVNode(UsersHistoryDialog, {
      entity: "ads_cabinets",
      object_id: _unref(modifiedId),
      visible: confirmVisible.value.history,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmVisible.value.history = false))
    }, null, 8, ["object_id", "visible"])
  ], 64))
}
}

})